module.exports = __webpack_public_path__ + "img/division-bulge.1bf19582.png";